import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

const loginButtonStyles = {
  px: 4,
  py: 1.5,
  fontSize: '0.95rem',
  fontWeight: 600,
  borderRadius: '10px',
  bgcolor: '#63b3ed',
  color: '#1a1e27',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.4)',
  transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
  '&:hover': {
    bgcolor: '#4299e1',
    transform: 'translateY(-5px) scale(1.03)',
    boxShadow: '0 12px 25px rgba(0, 0, 0, 0.5)',
  },
  '&:focus': {
    boxShadow: '0 0 0 4px rgba(99, 179, 237, 0.5)',
  },
};

export const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <Button
      onClick={() =>
        loginWithRedirect({
          appState: {
            returnTo: `${globalThis.location.pathname}${globalThis.location.search}`,
          },
        })
      }
      sx={loginButtonStyles}
    >
      Log In
    </Button>
  );
};
